import { Transition } from '@headlessui/react'
import { ReloadIcon } from '@radix-ui/react-icons'
import { useTranslation } from 'react-i18next'
import { Button } from '#app/components/ui/button.tsx'
import { getButtonText } from './getButtonText.ts'

interface FormNavigationProps {
	showPrevious: boolean
	isBusy: string
	isLastStep: boolean
	handlePreviousClick: () => void
	onSubmit: (currentFormContext: any) => Promise<void>
	getValues: Function
	fieldKey: string
	isValid: boolean
	formHasBeenCompleted: boolean
	completedFormProps: {
		completedButtonText: string
	}
}

export const FormNavigation = ({
	showPrevious,
	isBusy,
	isLastStep,
	handlePreviousClick,
	onSubmit,
	getValues,
	fieldKey,
	isValid,
	formHasBeenCompleted,
	completedFormProps,
}: FormNavigationProps) => {
	const { t } = useTranslation('form')

	return (
		<div
			className={`mb-16 flex items-center md:mb-24 md:min-h-[6rem] ${
				showPrevious ? 'gap-4' : ''
			}`}
		>
			<Transition
				show={showPrevious && !formHasBeenCompleted}
				enter="transition-opacity duration-300"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="transition-opacity duration-300"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
				className={`duration-750 transition-all ${
					showPrevious ? 'flex-1' : 'w-0'
				}`}
			>
				<Button
					type="button"
					variant="outline"
					className="h-12 w-full"
					disabled={isBusy !== 'idle'}
					onClick={handlePreviousClick}
				>
					{t('general.previous')}
				</Button>
			</Transition>

			<div
				className={`flex-1 transition-all duration-200 ${
					!showPrevious || !formHasBeenCompleted ? 'flex-grow' : ''
				}`}
			>
				<Button
					type="submit"
					onClick={() => {
						onSubmit({
							[fieldKey]: getValues(fieldKey),
						})
					}}
					className="h-12 w-full"
					disabled={(!isValid && !formHasBeenCompleted) || isBusy !== 'idle'}
				>
					{isBusy !== 'idle' && (
						<ReloadIcon className="animate-spin mr-2 h-4 w-4" />
					)}
					{getButtonText({
						isLastStep,
						isBusy,
						formHasBeenCompleted,
						formCompletedText: completedFormProps?.completedButtonText,
						t,
					})}
				</Button>
			</div>
		</div>
	)
}
